import React, { useState } from "react";
import { X } from "lucide-react";

export default function EditBillingModal({
  field,
  initialNominal = 0,
  initialPercentage = 0,
  subtotal = 0,
  onClose,
  onSave,
}) {
  const isDiscount = field === "discount";
  const title = isDiscount ? "Tambah Diskon" : "Tambah Biaya Tambahan";

  const [nominal, setNominal] = useState(
    initialNominal > 0 ? initialNominal.toLocaleString("id-ID") : "",
  );
  const [percentage, setPercentage] = useState(
    initialPercentage > 0 ? String(initialPercentage) : "",
  );

  const handleNominalChange = (e) => {
    const raw = e.target.value.replace(/\./g, "").replace(/[^0-9]/g, "");
    setNominal(raw ? parseInt(raw).toLocaleString("id-ID") : "");
    // sync percentage if subtotal available
    if (isDiscount && subtotal > 0 && raw) {
      const pct = ((parseInt(raw) / subtotal) * 100).toFixed(2);
      setPercentage(pct);
    } else if (!raw) {
      setPercentage("");
    }
  };

  const handlePercentageChange = (e) => {
    const raw = e.target.value.replace(/[^0-9.]/g, "");
    setPercentage(raw);
    // sync nominal
    if (subtotal > 0 && raw) {
      const nom = Math.round((parseFloat(raw) / 100) * subtotal);
      setNominal(nom.toLocaleString("id-ID"));
    } else if (!raw) {
      setNominal("");
    }
  };

  const handleSave = () => {
    const nominalValue = parseInt(nominal.replace(/\./g, "")) || 0;
    const pctValue = parseFloat(percentage) || 0;
    onSave({ nominal: nominalValue, percentage: pctValue });
    onClose();
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] modal-backdrop-enter">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden modal-panel-enter">
        {/* Teal header */}
        <div className="bg-teal-500 px-6 py-4 flex items-center justify-between">
          <h3 className="text-white font-bold text-lg">{title}</h3>
          <button
            onClick={onClose}
            className="text-white hover:text-teal-100 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5">
          {/* Nominal */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Nominal
            </label>
            <div className="flex overflow-hidden border border-gray-300 rounded-xl focus-within:ring-2 focus-within:ring-teal-500 focus-within:border-teal-500">
              <span className="px-4 py-3 bg-gray-100 text-gray-500 font-medium text-sm border-r border-gray-300">
                Rp
              </span>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                value={nominal}
                onChange={handleNominalChange}
                placeholder="0,-"
                className="flex-1 px-4 py-3 text-gray-800 focus:outline-none bg-white"
              />
            </div>
          </div>

          {/* Persentase — only for discount */}
          {isDiscount && (
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Persentase
              </label>
              <div className="flex overflow-hidden border border-gray-300 rounded-xl focus-within:ring-2 focus-within:ring-teal-500 focus-within:border-teal-500">
                <input
                  type="text"
                  inputMode="decimal"
                  value={percentage}
                  onChange={handlePercentageChange}
                  placeholder="0"
                  className="flex-1 px-4 py-3 text-gray-800 focus:outline-none bg-white"
                />
                <span className="px-4 py-3 bg-gray-100 text-gray-500 font-medium text-sm border-l border-gray-300">
                  %
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 pb-6 border-t border-gray-100 pt-4 flex justify-end">
          <button
            onClick={handleSave}
            className="px-8 py-3 bg-teal-500 text-white rounded-xl font-semibold hover:bg-teal-600 transition-colors">
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
}
